import { useQuery } from "react-query";

const fetchStoreInfo = async () => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_REACT_APP_API_URL}/api/store-info`
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  } catch (error) {
    console.log(error);
  }
};

export const useStoreInfo = () => {
  const { data, isLoading } = useQuery({
    queryKey: [`storeInfo`],
    queryFn: () => fetchStoreInfo(),
  });

  return {
    data,
    isLoading,
  };
};
